import React, { Fragment } from 'react'
import cx from 'classnames'
import InfoIcon from '@material-ui/icons/Info'
import { withStyles } from '@material-ui/core/styles'
import Tooltip from '@material-ui/core/Tooltip'

import { grayColor } from "shared/assets/jss/material-dashboard-pro-react"
import { withIntl } from "@hlcr/ui/Intl"
import IconCard from '../../../../shared/components/Cards/IconCard'
import Table from '../../../../components/Table/Table'
import LevelLabel from '../../../../shared/components/LevelLabel/LevelLabel'
import { categoryImages } from "shared/models/category.model"
import { QuizModel } from "shared/models/quiz.model"

const infoSectionStyles = {
	typeIcon: {
		color: grayColor,
		height: 24
	},
	tooltip: {
		fontSize: '1.2em',
		letterSpacing: '.05em'
	},
	summaryBox: {
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'center',
		'& > div': {
			marginRight: 6
		}
	},
	categoryImage: {
		width: 36,
		height: 36
	},
	spacer: {
		marginRight: 6
	}
}

const InfoSection = ({ quiz, unitType, classes, intl }) => {
	return (
		<IconCard
			icon={InfoIcon}
			title={intl.fm('quiz.properties')}
			content={
				<InfoSectionTable
					quiz={quiz}
					unitType={unitType}
					classes={classes}
					intl={intl}
				/>
			}
		/>
	)
}

const categories = (quiz: QuizModel, classes) => (
	<div>
		<Fragment>
			{quiz.categories.map((category, index) => {
				const imageSrc = categoryImages[category]
				return imageSrc ? (
					<Tooltip
						title={<span>{category.toUpperCase().replace('_', ' ')}</span>}
						placement="top"
						key={index}
					>
						<img
							src={imageSrc}
							alt={category}
							className={cx(classes.categoryImage, {
								[classes.spacer]: index !== quiz.categories.length - 1
							})}
						/>
					</Tooltip>
				) : (
					<span className={classes.categoryText} key={index}>
						{category.toUpperCase().replace('_', ' ')}
					</span>
				)
			})}
		</Fragment>
	</div>
)

const quizLevel = (quiz, intl) => (
	<div>
		{quiz.level ? (
			<LevelLabel level={quiz.level} />
		) : (
			intl.fm('common.labels.unknown')
		)}
	</div>
)

const quizBasicValue = value => <div>{value}</div>

const quizKeywords = usages => (
	<div>
		{usages.map((usage, index) => (index === 0 ? usage : `, ${usage}`))}
	</div>
)

const quizIsPublic = (isPublic, intl) => (
	<div>{isPublic ? intl.fm(`quiz.public`) : intl.fm(`quiz.private`)}</div>
)

const InfoSectionTable = ({ quiz, event, unitType, classes, intl }) => {
	const tableRenderer = [
		{ renderCell: row => row.title },
		{ renderCell: row => row.value }
	]

	let tableData = [
		{
			title: 'Name',
			value: quizBasicValue(quiz.name)
		},
		{
			title: 'UUID',
			value: quizBasicValue(quiz.uuid)
		},
		{
			title: intl.fm('event.table.level'),
			value: quizLevel(quiz, intl)
		},
		{
			title: intl.fm('quiz.access'),
			value: quizIsPublic(quiz.isPublic, intl)
		},
		{
			title: intl.fm('quiz.keywords'),
			value: quizKeywords(quiz.keywords)
		},
		{
			title: intl.fm('event.table.categories'),
			value: categories(quiz, classes)
		}
	]
	return <Table tableRenderer={tableRenderer} tableData={tableData} hover />
}

export default withIntl(withStyles(infoSectionStyles)(InfoSection))
